export default __webpack_public_path__ + "static/media/presentation-view.2bc82675.png";